<template>
  <div
    v-if="isVisibleComponent"
    data-qa="award-winner"
  >
    <div
      class="d-inline-flex align-center py-1 px-2 rounded bg-warning cursor-pointer"
      @click.prevent="isActive = !isActive"
    >
      <div class="ui-icon-rating-40 rating--text" />
      <div class="text-body-2 text--text ml-2">
        {{ title }}
      </div>
    </div>
    <AwardDialog
      :type="type"
      :title="title"
      :is-active="isActive"
      :current-award-year="currentAwardYear"
      @input="handleInput"
      @redirect="handleRedirect"
    />
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  Ref,
  nextTick,
  computed,
} from 'vue'
import i18next from 'i18next'
import AwardDialog from 'www/vue_components/common/AwardWinner/components/AwardDialog.vue'

const props = defineProps<{
  type: 'doctor' | 'lpu'
  redirectUrl: string
  currentAwardYear: number
  isAwardOrGrandPrixWinner: boolean
}>()
const isActive: Ref<boolean> = ref(false)
const isVisibleComponent: Ref<boolean> = computed(() => Boolean(
  props.currentAwardYear && props.isAwardOrGrandPrixWinner,
))
const title = `${i18next.t('Выбор пациентов', { ns: i18next.language })} ${props.currentAwardYear}`

function handleInput(val: boolean) {
  isActive.value = val
}

async function handleRedirect() {
  isActive.value = false
  await nextTick()
  window.location.assign(props.redirectUrl)
}
</script>
